import { useEffect } from 'react';

interface RedirectRouteProps {
  to: string;
}

const RedirectRoute: React.FC<RedirectRouteProps> = ({ to }) => {
  useEffect(() => {
    // Use replace to avoid adding to browser history (SEO-friendly 301 redirect behavior)
    window.location.replace(to);
  }, [to]);

  // Return null as this component doesn't render anything
  return null;
};

export default RedirectRoute;